import { render, staticRenderFns } from "./UpdateOnboardingWorkflow.vue?vue&type=template&id=6a3b07d4&scoped=true&"
import script from "./UpdateOnboardingWorkflow.vue?vue&type=script&lang=js&"
export * from "./UpdateOnboardingWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./UpdateOnboardingWorkflow.vue?vue&type=style&index=0&id=6a3b07d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3b07d4",
  null
  
)

export default component.exports